import { render, staticRenderFns } from "./gongzuo.vue?vue&type=template&id=5473cc3a&scoped=true&"
import script from "./gongzuo.vue?vue&type=script&lang=js&"
export * from "./gongzuo.vue?vue&type=script&lang=js&"
import style0 from "./gongzuo.vue?vue&type=style&index=0&id=5473cc3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5473cc3a",
  null
  
)

export default component.exports